"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../../constants");
var _context = require("../../../context");
var _enums = require("../../../types/enums");
var _tooltipContent = require("../tooltip-content.css");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const BuildSuccessTooltipContent = () => {
  const {
    manifestInfo,
    buildInfo,
    isOnPrettyUrl,
    trackEvent
  } = (0, _react.useContext)(_context.IndicatorContext);
  const newPreviewAvailableClick = async () => {
    trackEvent({
      eventType: _enums.EventType.PREVIEW_INDICATOR_CLICK,
      name: `new preview`
    });

    /**
     * Delay to ensure that track event fires but do not await trackEvent directly since we do not
     * want to block the thread until the event request comes back
     */
    setTimeout(() => {
      const isLocalhost = window.location.hostname === `localhost`;
      if (manifestInfo !== null && manifestInfo !== void 0 && manifestInfo.redirectUrl) {
        window.location[isLocalhost ? `assign` : `replace`](manifestInfo === null || manifestInfo === void 0 ? void 0 : manifestInfo.redirectUrl);
      } else if (isOnPrettyUrl() || isLocalhost) {
        window.location.reload();
      } else {
        var _buildInfo$siteInfo;
        // Grabs domain that preview is hosted on https://preview-sitePrefix.gtsb.io
        // This will match `gtsb.io`
        const previewDomain = window.location.hostname.split(`.`).slice(-2).join(`.`);
        window.location.replace(`https://preview-${buildInfo === null || buildInfo === void 0 ? void 0 : (_buildInfo$siteInfo = buildInfo.siteInfo) === null || _buildInfo$siteInfo === void 0 ? void 0 : _buildInfo$siteInfo.sitePrefix}.${previewDomain}${window.location.pathname}`);
      }
    }, 75);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _constants.messages.pageHasBeenUpdated, /*#__PURE__*/_react.default.createElement("button", {
    onClick: newPreviewAvailableClick,
    className: _tooltipContent.linkWrapperStyle
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _tooltipContent.linkTextStyle
  }, _constants.messages.viewChanges)));
};
var _default = BuildSuccessTooltipContent;
exports.default = _default;